import { RETURN_INVOICE_REQUEST } from 'collections/invoiceConstants';
import { Regions } from 'config/regions/types';

export const GROUP_TRANSLATIONS = {
  Deal: 'Deals',
  'Deal::Part': 'Production Parts',
  Provider: 'Partners',
  Organization: 'Organizations',
  Person: 'Persons',
  Enquiry: 'Quotes',
  'Enquiry::Part': 'Quote Parts',
  'Enquiry::Promotion': 'Coupons',
  'Deal::OrderConfirmation': 'Order Confirmations',
  Job: 'Jobs',
  'Deal::ProviderOrder': 'Provider Orders',
  'Deal::Claim': 'Claims',
  'Deal::Shipping': 'Shippings',
  'Deal::QualityControl': 'Quality Controls',
  'Deal::Storage': 'Storages',
  'Deal::OutcomingInvoice': 'Outcoming Invoices',
  'Deal::IncomingInvoice': 'Incoming Invoices',
  'Deal::Payment': 'Payments',
};

export const GROUP_LINKS = {
  Deal: 'deals',
  Provider: 'providers',
  Organization: 'organizations',
  Person: 'persons',
  Enquiry: 'enquiries',
  'Enquiry::Part': 'enquiry_parts',
  'Enquiry::Promotion': 'enquiry_promotions',
  'Deal::OrderConfirmation': 'order_confirmations',
  Job: 'jobs',
  'Deal::Part': 'deal_parts',
  'Deal::ProviderOrder': 'provider_orders',
  'Deal::Claim': 'claims',
  'Deal::Shipping': 'shippings',
  'Deal::QualityControl': 'quality_controls',
  'Deal::Storage': 'storages',
  'Deal::OutcomingInvoice': 'outcoming_invoices',
  'Deal::IncomingInvoice': 'incoming_invoices',
  'Deal::Payment': 'payments',
};

export const shortPatternByGroup: Record<keyof typeof GROUP_LINKS, RegExp> = {
  Deal: /^(deal|d)?(-|\s)?(\d+(-|\s)?)?\d+/i,
  Provider: /^(pr)(-|\s)?\d+$/i,
  Organization: /^(o)(-|\s)?(\d+(-|\s)?)?\d+/i,
  Person: /^(p)(-|\s)?(\d+(-|\s)?)?\d+/i,
  Enquiry: /^(enq|e)(-|\s)?(\d+(-|\s)?)?\d+/i,
  'Enquiry::Part': /^(qp)(-|\s)?(\d+(-|\s)?)?\d+/i,
  'Enquiry::Promotion': /^(promo|ep)(-|\s)?(\d+(-|\s)?)?\d+/i,
  'Deal::OrderConfirmation': /^(oc)(-|\s)?(\d+(-|\s)?)?\d+/i,
  Job: /^(j)(-|\s)?(\d+(-|\s)?)?\d+/i,
  'Deal::Part': /^(part|pp)(-|\s)?(\d+(-|\s)?)?\d+/i,
  'Deal::ProviderOrder': /^(po)(-|\s)?(\d+(-|\s)?)?\d+/i,
  'Deal::Claim': /^(cl|claim)(-|\s)?(\d+(-|\s)?)?\d+/i,
  'Deal::Shipping': /^(sh)(-|\s)?(\d+(-|\s)?)?\d+/i,
  'Deal::QualityControl': /^(qc)(-|\s)?(\d+(-|\s)?)?\d+/i,
  'Deal::Storage': /^(su)(-|\s)?(\d+(-|\s)?)?\d+/i,
  'Deal::OutcomingInvoice': /^(g|cn)(-|\s)?(\d+(-|\s)?)?\d+/i,
  'Deal::IncomingInvoice': /^(ii|lr|lg|xlr|xlg)(-|\s)?(\d+(-|\s)?)?\d+/i,
  'Deal::Payment': /^(pi|rf)(-|\s)?(\d+(-|\s)?)?\d+/i,
};

export const CREDIT_NOTE_NAME: Record<Regions, string> = {
  [Regions.EU]: 'Credit Note',
  [Regions.TR]: RETURN_INVOICE_REQUEST,
  [Regions.UK]: 'Credit Note',
  [Regions.SG]: 'Credit Note',
};

export const STATE_MAPPING = {
  found_by_us: { label: 'Found By Us', color: '#1979C3' },
  enrolled_via_website: { label: 'Enrolled Via Website', color: '#2690DD' },
  probation: { label: 'Probation', color: '#73BE7F' },
  test_part: { label: 'Test part', color: '#D46B08' },
  lost: { label: 'lost', color: '#EB5757' },
  not_processed: { label: 'not processed', color: '#EB5757' },
  expired: { label: 'expired', color: '#EB5757' },
  completed: { label: 'completed', color: '#EB5757' },
  won: { label: 'won', color: '#219653' },
  shipped: { label: 'shipped', color: '#219653' },
  delivered: { label: 'delivered', color: '#219653' },
  processed: { label: 'processed', color: '#219653' },
  placed: { label: 'placed', color: '#219653' },
  submitted: { label: 'submitted', color: '#219653' },
  open: { label: 'open', color: '#096DD9' },
  published: { label: 'published', color: '#73BE7F' },
  trusted: { label: 'Trusted', color: '#219653' },
  blacklist: { label: 'Blacklist', color: '#9E3C3C' },
  deleted: { label: 'Deleted', color: '#9E3C3C' },
  canceled: { label: 'canceled', color: '#9E3C3C' },
};
